import {Injectable} from '@angular/core';
import {RequestHandler} from '../OffService/request-handler';
import {SyncService} from '../OffService/sync.service';
import {ApiRequestService, HttpRequestType} from '../OffService/api-request.service';

@Injectable({
    providedIn: 'root'
})
export class FincasApiService {

    public fincasGET: RequestHandler = new RequestHandler();
    public fincasDELETE: RequestHandler = new RequestHandler();
    public fincasPUT: RequestHandler = new RequestHandler();
    public fincasPOST: RequestHandler = new RequestHandler();

    public sectoresGET: RequestHandler = new RequestHandler();
    public sectoresDELETE: RequestHandler = new RequestHandler();
    public sectoresPUT: RequestHandler = new RequestHandler();
    public sectoresPOST: RequestHandler = new RequestHandler();

    public parcelasGET: RequestHandler = new RequestHandler();
    public parcelasDELETE: RequestHandler = new RequestHandler();
    public parcelasPUT: RequestHandler = new RequestHandler();
    public parcelasPOST: RequestHandler = new RequestHandler();


    constructor(private syncService: SyncService,
        private api: ApiRequestService) {

        this.defineFincasGET();
        this.defineFincasPUT();
        this.defineFincasPOST();
        this.defineFincasDELETE();

        this.defineSectoresGET();
        this.defineSectoresPUT();
        this.defineSectoresPOST();
        this.defineSectoresDELETE();

        this.defineParcelasGET();
        this.defineParcelasPUT();
        this.defineParcelasPOST();
        this.defineParcelasDELETE();
    }

    private defineFincasGET() {
        this.fincasGET
            .fetch(HttpRequestType.GET, 'fincas/get');

        this.api
            .registerRequest(this.fincasGET);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.fincasGET));
    }

    private defineFincasPUT() {
        this.fincasPUT
            .fetch(HttpRequestType.PUT, 'generic/fincas');

        this.api
            .registerRequest(this.fincasPUT);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.fincasPUT));
    }

    private defineFincasPOST() {
        this.fincasPOST
            .fetch(HttpRequestType.POST, 'generic/fincas');

        this.api
            .registerRequest(this.fincasPOST);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.fincasPOST));
    }

    private defineFincasDELETE() {
        this.fincasDELETE
            .fetch(HttpRequestType.DELETE, 'generic/fincas');

        this.api
            .registerRequest(this.fincasDELETE);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.fincasDELETE));
    }

    private defineSectoresGET() {
        this.sectoresGET
            .fetch(HttpRequestType.GET, 'sectores/get');

        this.api
            .registerRequest(this.sectoresGET);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.sectoresGET));
    }

    private defineSectoresPUT() {
        this.sectoresPUT
            .fetch(HttpRequestType.PUT, 'generic/sectores');

        this.api
            .registerRequest(this.sectoresPUT);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.sectoresPUT));
    }

    private defineSectoresPOST() {
        this.sectoresPOST
            .fetch(HttpRequestType.POST, 'generic/sectores');

        this.api
            .registerRequest(this.sectoresPOST);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.sectoresPOST));
    }

    private defineSectoresDELETE() {
        this.sectoresDELETE
            .fetch(HttpRequestType.DELETE, 'generic/sectores');

        this.api
            .registerRequest(this.sectoresDELETE);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.sectoresDELETE));
    }

    private defineParcelasGET() {
        this.parcelasGET
            .fetch(HttpRequestType.GET, 'parcelas/get');

        this.api
            .registerRequest(this.parcelasGET);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.parcelasGET));
    }

    private defineParcelasPUT() {
        this.parcelasPUT
            .fetch(HttpRequestType.PUT, 'generic/parcelas');

        this.api
            .registerRequest(this.parcelasPUT);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.parcelasPUT));
    }

    private defineParcelasPOST() {
        this.parcelasPOST
            .fetch(HttpRequestType.POST, 'generic/parcelas');

        this.api
            .registerRequest(this.parcelasPOST);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.parcelasPOST));
    }

    private defineParcelasDELETE() {
        this.parcelasDELETE
            .fetch(HttpRequestType.DELETE, 'generic/parcelas');

        this.api
            .registerRequest(this.parcelasDELETE);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.parcelasDELETE));
    }


}
